import Vue from 'vue'
import Router from 'vue-router'

const Not = () =>
    import ('@/components/404')
const Login = () =>
    import ('@/components/Login')
const QQLogin = () =>
    import ('@/components/QQLogin')
const WechatLogin = () =>
    import ('@/components/WechatLogin')
const Register = () =>
    import ('@/components/Register')
const Reset = () =>
    import ('@/components/ResetPwd')
const ThirdLogin = () =>
    import ('@/components/ThirdLogin')
const Declaration = () =>
    import ('@/components/Declaration')
const UnionLogin = () =>
    import ('@/components/UnionLogin')
const Signup = () =>
    import ('@/components/Signup')
const BeforeSignup = () =>
    import ('@/components/BeforeSignup')
const TencentEdu = () =>
    import ('@/components/TencentEdu')
const NationalEdu = () =>
    import ('@/components/NationalEdu')
const CdchqEdu = () =>
    import ('@/components/CdchqEdu')
const AppLogin = () =>
    import ('@/components/AppLogin')
const appRegister = () =>
    import ('@/components/appRegister')
const appResetPwd = () =>
    import ('@/components/appResetPwd')
const sxjUnionLogin = () =>
    import ('@/components/sxj_unionlogin.vue')
const ask_UnionLogin = () =>
    import ('@/components/ask_unionlogin.vue')
const tyy_UnionLogin = () =>
    import ('@/components/tyy_UnionLogin.vue')

Vue.use(Router)

export default new Router({
    //mode:'history',//history模式下IE无法使用
    base: '/oauthui/',
    routes: [{
            path: '*',
            component: Not
        },
        {
            path: '/',
            component: Login,
        },
        {
            path: '/reset',
            component: Reset
        },
        {
            path: '/appResetPwd',
            component: appResetPwd
        },
        {
            path: '/declaration',
            component: Declaration
        },
        {
            path: '/register',
            component: Register
        },
        {
            path: '/appRegister',
            component: appRegister
        },
        {
            path: '/login',
            component: Login,
        },
        {
            path: '/AppLogin',
            component: AppLogin,
        },
        {
            path: '/login/qq',
            component: QQLogin
        },
        {
            path: '/login/wechat',
            component: WechatLogin
        },
        {
            path: '/login/nationalEdu',
            component: NationalEdu
        },
        {
            path: '/login/cdchqEdu',
            component: CdchqEdu
        },
        {
            path: '/login/tencentEdu',
            component: TencentEdu
        },
        {
            path: '/login/third',
            component: ThirdLogin
        },
        {
            path: '/login/signup',
            component: Signup
        },
        {
            path: '/login/union',
            component: UnionLogin
        },
        {
            path: '/login/beforeSignup',
            component: BeforeSignup
        },
        {
            path: '/login/sxj_unionlogin',
            component: sxjUnionLogin
        },
        {
            path: '/login/ask_unionlogin',
            component: ask_UnionLogin
        },
        {
            path: '/login/tyy_unionlogin',
            component: tyy_UnionLogin
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js